









































import { Component, Prop, Vue } from "vue-property-decorator";
import { CommentType, PostClass } from "../../../types";

import NewComment from "./NewComment.vue";
import CommentsList from "./CommentsList.vue";
import { deletePost } from "../../../helpers/post-getter";

@Component({
  components: { NewComment, CommentsList },
})
export default class Post extends Vue {
  @Prop() private post!: PostClass;
  @Prop() private position_in_array!: number;

  private is_admin = this.$store.state.user.admin;
  private error = "";
  private is_image_valid = false;

  mounted() {
    this.is_image_valid = !!this.post.image_url;
  }

  invalidateImage() {
    this.is_image_valid = false;
  }

  addComment(new_comment: CommentType) {
    this.post.comments.unshift(new_comment);
  }

  erasePost() {
    deletePost(this.post.id)
      .then(() => {
        this.$emit("post-deleted", this.position_in_array);
        this.error = "";
      })
      .catch((err) => {
        this.error = err.message;
      });
  }
}
